// Element used for Contractor's choice form.
import React from 'react';

// Component will show if contractor's choice option is selected.
const Contractor = (props) => {
    return (
      <div className={'contractor show'}>
        <label htmlFor="company" className="required">Company</label>
        <input 
          type="text" 
          name="company" 
          id="company" 
          value={props.preferences.company || ''} 
          onChange={props.handleContractorChoice} 
          required
        ></input>
        <label htmlFor="phoneNumber" className="">Phone</label>
        <input type="tel" 
          name="phoneNumber" 
          id="phoneNumber" 
          placeholder="(555) 555-5555" 
          pattern="^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$" 
          value={props.preferences.phoneNumber || ''} 
          onChange={props.handleContractorChoice} 
        ></input>
        <label htmlFor="tradeSpeciality">Trade / Speciality</label>
        <input type="text" 
          name="tradeSpeciality" 
          id="tradeSpeciality" 
          value={props.preferences.tradeSpeciality || ''} 
          onChange={props.handleContractorChoice} 
        ></input>
      </div>
    )
  }

  export default Contractor;